
const Noroute = () => {
    return ( <><h2>  404 <br></br>
      Sorry,but we couldn't find what you are looking for
  </h2>
  <footer>
      <p>&copy; 2024 NoNet. All rights reserved.</p>
      </footer>
      </>)
  }

export default Noroute